'use client';

import { FEATURE_FLAG_KEYS } from 'shop-ui/constants';

export enum GRID_LAYOUT_TYPE {
    SINGLE_CELL = 'single-cell',
    SPLIT_H_2C = 'split-h-2c',
    SPLIT_H_3C = 'split-h-3c',
    SPLIT_H_4C = 'split-h-4c',
    SPLIT_V_2C = 'split-v-2c',
    SPLIT_V_3C = 'split-v-3c',
    SPLIT_V_4C = 'split-v-4c',
    SPLIT_V_1C_2C = 'split-v-1c-2c',
    SPLIT_V_2C_1C = 'split-v-2c-1c',
    SPLIT_V_1C_3C = 'split-v-1c-3c',
    SPLIT_V_3C_1C = 'split-v-3c-1c',
    SPLIT_H_1C_2C = 'split-h-1c-2c',
    SPLIT_H_2C_1C = 'split-h-2c-1c',
    SPLIT_H_1C_3C = 'split-h-1c-3c',
    SPLIT_H_3C_1C = 'split-h-3c-1c',
    SPLIT_2CX2 = 'split-2cx2',
    SPLIT_2CX3 = 'split-2cx3',
    SPLIT_3CX2 = 'split-3cx2',
    SPLIT_3CX3 = 'split-3cx3',
    FIXED_SPLIT_H_2C = 'fixed-split-h-2c',
    FIXED_SPLIT_H_3C = 'fixed-split-h-3c',
    FIXED_SPLIT_H_4C = 'fixed-split-h-4c',
}

export enum GRID_CELL_MAP {
    CELL_1 = 'grid-cell-1',
    CELL_2 = 'grid-cell-2',
    CELL_3 = 'grid-cell-3',
    CELL_4 = 'grid-cell-4',
    CELL_5 = 'grid-cell-5',
    CELL_6 = 'grid-cell-6',
    CELL_7 = 'grid-cell-7',
    CELL_8 = 'grid-cell-8',
    CELL_9 = 'grid-cell-9',
}

export const columnCountMap = {
    [GRID_LAYOUT_TYPE.SINGLE_CELL]: 1,
    [GRID_LAYOUT_TYPE.SPLIT_H_2C]: 2,
    [GRID_LAYOUT_TYPE.SPLIT_H_3C]: 3,
    [GRID_LAYOUT_TYPE.SPLIT_H_4C]: 4,
    [GRID_LAYOUT_TYPE.SPLIT_V_2C]: 2,
    [GRID_LAYOUT_TYPE.SPLIT_V_3C]: 3,
    [GRID_LAYOUT_TYPE.SPLIT_V_4C]: 4,
    [GRID_LAYOUT_TYPE.SPLIT_V_1C_2C]: 3,
    [GRID_LAYOUT_TYPE.SPLIT_V_2C_1C]: 3,
    [GRID_LAYOUT_TYPE.SPLIT_V_1C_3C]: 4,
    [GRID_LAYOUT_TYPE.SPLIT_V_3C_1C]: 4,
    [GRID_LAYOUT_TYPE.SPLIT_H_1C_2C]: 3,
    [GRID_LAYOUT_TYPE.SPLIT_H_2C_1C]: 3,
    [GRID_LAYOUT_TYPE.SPLIT_H_1C_3C]: 4,
    [GRID_LAYOUT_TYPE.SPLIT_H_3C_1C]: 4,
    [GRID_LAYOUT_TYPE.SPLIT_2CX2]: 4,
    [GRID_LAYOUT_TYPE.SPLIT_2CX3]: 6,
    [GRID_LAYOUT_TYPE.SPLIT_3CX2]: 6,
    [GRID_LAYOUT_TYPE.SPLIT_3CX3]: 9,
    [GRID_LAYOUT_TYPE.FIXED_SPLIT_H_2C]: 2,
    [GRID_LAYOUT_TYPE.FIXED_SPLIT_H_3C]: 3,
    [GRID_LAYOUT_TYPE.FIXED_SPLIT_H_4C]: 4,
};

export const templateMap = {
    [GRID_LAYOUT_TYPE.SINGLE_CELL]: `${GRID_CELL_MAP.CELL_1}`,
    [GRID_LAYOUT_TYPE.SPLIT_H_2C]: `${GRID_CELL_MAP.CELL_1} ${GRID_CELL_MAP.CELL_2}`,
    [GRID_LAYOUT_TYPE.SPLIT_H_3C]: `${GRID_CELL_MAP.CELL_1} ${GRID_CELL_MAP.CELL_2} ${GRID_CELL_MAP.CELL_3}`,
    [GRID_LAYOUT_TYPE.SPLIT_H_4C]: `${GRID_CELL_MAP.CELL_1} ${GRID_CELL_MAP.CELL_2} ${GRID_CELL_MAP.CELL_3} ${GRID_CELL_MAP.CELL_4}`,
    [GRID_LAYOUT_TYPE.SPLIT_V_2C]: `
        ${GRID_CELL_MAP.CELL_1}
        ${GRID_CELL_MAP.CELL_2}
    `,
    [GRID_LAYOUT_TYPE.SPLIT_V_3C]: `
        ${GRID_CELL_MAP.CELL_1}
        ${GRID_CELL_MAP.CELL_2}
        ${GRID_CELL_MAP.CELL_3}
    `,
    [GRID_LAYOUT_TYPE.SPLIT_V_4C]: `
        ${GRID_CELL_MAP.CELL_1}
        ${GRID_CELL_MAP.CELL_2}
        ${GRID_CELL_MAP.CELL_3}
        ${GRID_CELL_MAP.CELL_4}
    `,
    [GRID_LAYOUT_TYPE.SPLIT_V_1C_2C]: `
        ${GRID_CELL_MAP.CELL_1} ${GRID_CELL_MAP.CELL_1}
        ${GRID_CELL_MAP.CELL_2} ${GRID_CELL_MAP.CELL_3}
    `,
    [GRID_LAYOUT_TYPE.SPLIT_V_2C_1C]: `
        ${GRID_CELL_MAP.CELL_1} ${GRID_CELL_MAP.CELL_2}
        ${GRID_CELL_MAP.CELL_3} ${GRID_CELL_MAP.CELL_3}
    `,
    [GRID_LAYOUT_TYPE.SPLIT_V_1C_3C]: `
        ${GRID_CELL_MAP.CELL_1} ${GRID_CELL_MAP.CELL_1} ${GRID_CELL_MAP.CELL_1}
        ${GRID_CELL_MAP.CELL_2} ${GRID_CELL_MAP.CELL_3} ${GRID_CELL_MAP.CELL_4}
    `,
    [GRID_LAYOUT_TYPE.SPLIT_V_3C_1C]: `
        ${GRID_CELL_MAP.CELL_1} ${GRID_CELL_MAP.CELL_2} ${GRID_CELL_MAP.CELL_3}
        ${GRID_CELL_MAP.CELL_4} ${GRID_CELL_MAP.CELL_4} ${GRID_CELL_MAP.CELL_4}
    `,
    [GRID_LAYOUT_TYPE.SPLIT_H_1C_2C]: `
        ${GRID_CELL_MAP.CELL_1} ${GRID_CELL_MAP.CELL_2}
        ${GRID_CELL_MAP.CELL_1} ${GRID_CELL_MAP.CELL_3}
    `,
    [GRID_LAYOUT_TYPE.SPLIT_H_2C_1C]: `
        ${GRID_CELL_MAP.CELL_1} ${GRID_CELL_MAP.CELL_3}
        ${GRID_CELL_MAP.CELL_2} ${GRID_CELL_MAP.CELL_3}
    `,
    [GRID_LAYOUT_TYPE.SPLIT_H_1C_3C]: `
        ${GRID_CELL_MAP.CELL_1} ${GRID_CELL_MAP.CELL_2}
        ${GRID_CELL_MAP.CELL_1} ${GRID_CELL_MAP.CELL_3}
        ${GRID_CELL_MAP.CELL_1} ${GRID_CELL_MAP.CELL_4}
    `,
    [GRID_LAYOUT_TYPE.SPLIT_H_3C_1C]: `
        ${GRID_CELL_MAP.CELL_1} ${GRID_CELL_MAP.CELL_4}
        ${GRID_CELL_MAP.CELL_2} ${GRID_CELL_MAP.CELL_4}
        ${GRID_CELL_MAP.CELL_3} ${GRID_CELL_MAP.CELL_4}
    `,
    [GRID_LAYOUT_TYPE.SPLIT_2CX2]: `
        ${GRID_CELL_MAP.CELL_1} ${GRID_CELL_MAP.CELL_2}
        ${GRID_CELL_MAP.CELL_3} ${GRID_CELL_MAP.CELL_4}
    `,
    [GRID_LAYOUT_TYPE.SPLIT_2CX3]: `
        ${GRID_CELL_MAP.CELL_1} ${GRID_CELL_MAP.CELL_2}
        ${GRID_CELL_MAP.CELL_3} ${GRID_CELL_MAP.CELL_4}
        ${GRID_CELL_MAP.CELL_5} ${GRID_CELL_MAP.CELL_6}
    `,
    [GRID_LAYOUT_TYPE.SPLIT_3CX2]: `
        ${GRID_CELL_MAP.CELL_1} ${GRID_CELL_MAP.CELL_2} ${GRID_CELL_MAP.CELL_3}
        ${GRID_CELL_MAP.CELL_4} ${GRID_CELL_MAP.CELL_5} ${GRID_CELL_MAP.CELL_6}
    `,
    [GRID_LAYOUT_TYPE.SPLIT_3CX3]: `
        ${GRID_CELL_MAP.CELL_1} ${GRID_CELL_MAP.CELL_2} ${GRID_CELL_MAP.CELL_3}
        ${GRID_CELL_MAP.CELL_4} ${GRID_CELL_MAP.CELL_5} ${GRID_CELL_MAP.CELL_6}
        ${GRID_CELL_MAP.CELL_7} ${GRID_CELL_MAP.CELL_8} ${GRID_CELL_MAP.CELL_9}
    `,
};

export enum GRID_CELL_CONTROLLER_POSITION {
    TOP = 'top',
    BOTTOM = 'bottom',
    LEFT = 'left',
    RIGHT = 'right',
}

export type FeatureCellTypeName =
    | typeof FEATURE_FLAG_KEYS.GRID_COLUMN_1
    | typeof FEATURE_FLAG_KEYS.GRID_COLUMN_2
    | typeof FEATURE_FLAG_KEYS.GRID_COLUMN_3
    | typeof FEATURE_FLAG_KEYS.GRID_COLUMN_4
    | typeof FEATURE_FLAG_KEYS.GRID_ROW_1
    | typeof FEATURE_FLAG_KEYS.GRID_ROW_2
    | typeof FEATURE_FLAG_KEYS.GRID_ROW_3
    | typeof FEATURE_FLAG_KEYS.GRID_ROW_4;

export const resizeCursorTargetMap = {
    [GRID_LAYOUT_TYPE.SPLIT_H_2C]: {
        0: [FEATURE_FLAG_KEYS.GRID_COLUMN_1, FEATURE_FLAG_KEYS.GRID_COLUMN_2],
    },
    [GRID_LAYOUT_TYPE.SPLIT_H_3C]: {
        0: [FEATURE_FLAG_KEYS.GRID_COLUMN_1, FEATURE_FLAG_KEYS.GRID_COLUMN_2],
        1: [FEATURE_FLAG_KEYS.GRID_COLUMN_2, FEATURE_FLAG_KEYS.GRID_COLUMN_3],
    },
    [GRID_LAYOUT_TYPE.SPLIT_H_4C]: {
        0: [FEATURE_FLAG_KEYS.GRID_COLUMN_1, FEATURE_FLAG_KEYS.GRID_COLUMN_2],
        1: [FEATURE_FLAG_KEYS.GRID_COLUMN_2, FEATURE_FLAG_KEYS.GRID_COLUMN_3],
        2: [FEATURE_FLAG_KEYS.GRID_COLUMN_3, FEATURE_FLAG_KEYS.GRID_COLUMN_4],
    },
    [GRID_LAYOUT_TYPE.SPLIT_V_2C]: {
        0: [FEATURE_FLAG_KEYS.GRID_ROW_1, FEATURE_FLAG_KEYS.GRID_ROW_2],
    },
    [GRID_LAYOUT_TYPE.SPLIT_V_3C]: {
        0: [FEATURE_FLAG_KEYS.GRID_ROW_1, FEATURE_FLAG_KEYS.GRID_ROW_2],
        1: [FEATURE_FLAG_KEYS.GRID_ROW_2, FEATURE_FLAG_KEYS.GRID_ROW_3],
    },
    [GRID_LAYOUT_TYPE.SPLIT_V_4C]: {
        0: [FEATURE_FLAG_KEYS.GRID_ROW_1, FEATURE_FLAG_KEYS.GRID_ROW_2],
        1: [FEATURE_FLAG_KEYS.GRID_ROW_2, FEATURE_FLAG_KEYS.GRID_ROW_3],
        2: [FEATURE_FLAG_KEYS.GRID_ROW_3, FEATURE_FLAG_KEYS.GRID_ROW_4],
    },
    [GRID_LAYOUT_TYPE.SPLIT_V_1C_2C]: {
        0: [FEATURE_FLAG_KEYS.GRID_ROW_1, FEATURE_FLAG_KEYS.GRID_ROW_2],
        1: [FEATURE_FLAG_KEYS.GRID_COLUMN_1, FEATURE_FLAG_KEYS.GRID_COLUMN_2],
    },
    [GRID_LAYOUT_TYPE.SPLIT_V_1C_3C]: {
        0: [FEATURE_FLAG_KEYS.GRID_ROW_1, FEATURE_FLAG_KEYS.GRID_ROW_2],
        1: [FEATURE_FLAG_KEYS.GRID_COLUMN_1, FEATURE_FLAG_KEYS.GRID_COLUMN_2],
        2: [FEATURE_FLAG_KEYS.GRID_COLUMN_2, FEATURE_FLAG_KEYS.GRID_COLUMN_3],
    },
    [GRID_LAYOUT_TYPE.SPLIT_V_2C_1C]: {
        0: [FEATURE_FLAG_KEYS.GRID_COLUMN_1, FEATURE_FLAG_KEYS.GRID_COLUMN_2],
        1: [FEATURE_FLAG_KEYS.GRID_ROW_1, FEATURE_FLAG_KEYS.GRID_ROW_2],
    },
    [GRID_LAYOUT_TYPE.SPLIT_V_3C_1C]: {
        0: [FEATURE_FLAG_KEYS.GRID_COLUMN_1, FEATURE_FLAG_KEYS.GRID_COLUMN_2],
        1: [FEATURE_FLAG_KEYS.GRID_COLUMN_2, FEATURE_FLAG_KEYS.GRID_COLUMN_3],
        2: [FEATURE_FLAG_KEYS.GRID_ROW_1, FEATURE_FLAG_KEYS.GRID_ROW_2],
    },
    [GRID_LAYOUT_TYPE.SPLIT_H_1C_2C]: {
        0: [FEATURE_FLAG_KEYS.GRID_COLUMN_1, FEATURE_FLAG_KEYS.GRID_COLUMN_2],
        1: [FEATURE_FLAG_KEYS.GRID_ROW_1, FEATURE_FLAG_KEYS.GRID_ROW_2],
    },
    [GRID_LAYOUT_TYPE.SPLIT_H_1C_3C]: {
        0: [FEATURE_FLAG_KEYS.GRID_COLUMN_1, FEATURE_FLAG_KEYS.GRID_COLUMN_2],
        1: [FEATURE_FLAG_KEYS.GRID_ROW_1, FEATURE_FLAG_KEYS.GRID_ROW_2],
        2: [FEATURE_FLAG_KEYS.GRID_ROW_2, FEATURE_FLAG_KEYS.GRID_ROW_3],
    },
    [GRID_LAYOUT_TYPE.SPLIT_H_2C_1C]: {
        0: [FEATURE_FLAG_KEYS.GRID_ROW_1, FEATURE_FLAG_KEYS.GRID_ROW_2],
        1: [FEATURE_FLAG_KEYS.GRID_COLUMN_1, FEATURE_FLAG_KEYS.GRID_COLUMN_2],
    },
    [GRID_LAYOUT_TYPE.SPLIT_H_3C_1C]: {
        0: [FEATURE_FLAG_KEYS.GRID_ROW_1, FEATURE_FLAG_KEYS.GRID_ROW_2],
        1: [FEATURE_FLAG_KEYS.GRID_ROW_2, FEATURE_FLAG_KEYS.GRID_ROW_3],
        2: [FEATURE_FLAG_KEYS.GRID_COLUMN_1, FEATURE_FLAG_KEYS.GRID_COLUMN_2],
    },
    [GRID_LAYOUT_TYPE.SPLIT_2CX2]: {
        0: [FEATURE_FLAG_KEYS.GRID_COLUMN_1, FEATURE_FLAG_KEYS.GRID_COLUMN_2],
        1: [FEATURE_FLAG_KEYS.GRID_ROW_1, FEATURE_FLAG_KEYS.GRID_ROW_2],
    },
    [GRID_LAYOUT_TYPE.SPLIT_2CX3]: {
        0: [FEATURE_FLAG_KEYS.GRID_COLUMN_1, FEATURE_FLAG_KEYS.GRID_COLUMN_2],
        1: [FEATURE_FLAG_KEYS.GRID_ROW_1, FEATURE_FLAG_KEYS.GRID_ROW_2],
        2: [FEATURE_FLAG_KEYS.GRID_ROW_2, FEATURE_FLAG_KEYS.GRID_ROW_3],
    },
    [GRID_LAYOUT_TYPE.SPLIT_3CX2]: {
        0: [FEATURE_FLAG_KEYS.GRID_COLUMN_1, FEATURE_FLAG_KEYS.GRID_COLUMN_2],
        1: [FEATURE_FLAG_KEYS.GRID_COLUMN_2, FEATURE_FLAG_KEYS.GRID_COLUMN_3],
        2: [FEATURE_FLAG_KEYS.GRID_ROW_1, FEATURE_FLAG_KEYS.GRID_ROW_2],
    },
    [GRID_LAYOUT_TYPE.SPLIT_3CX3]: {
        0: [FEATURE_FLAG_KEYS.GRID_COLUMN_1, FEATURE_FLAG_KEYS.GRID_COLUMN_2],
        1: [FEATURE_FLAG_KEYS.GRID_COLUMN_2, FEATURE_FLAG_KEYS.GRID_COLUMN_3],
        2: [FEATURE_FLAG_KEYS.GRID_ROW_1, FEATURE_FLAG_KEYS.GRID_ROW_2],
        3: [FEATURE_FLAG_KEYS.GRID_ROW_2, FEATURE_FLAG_KEYS.GRID_ROW_3],
    },
    [GRID_LAYOUT_TYPE.FIXED_SPLIT_H_2C]: {
        0: [FEATURE_FLAG_KEYS.GRID_COLUMN_1, FEATURE_FLAG_KEYS.GRID_COLUMN_2],
    },
    [GRID_LAYOUT_TYPE.FIXED_SPLIT_H_3C]: {
        0: [FEATURE_FLAG_KEYS.GRID_COLUMN_1, FEATURE_FLAG_KEYS.GRID_COLUMN_2],
        1: [FEATURE_FLAG_KEYS.GRID_COLUMN_2, FEATURE_FLAG_KEYS.GRID_COLUMN_3],
    },
    [GRID_LAYOUT_TYPE.FIXED_SPLIT_H_4C]: {
        0: [FEATURE_FLAG_KEYS.GRID_COLUMN_1, FEATURE_FLAG_KEYS.GRID_COLUMN_2],
        1: [FEATURE_FLAG_KEYS.GRID_COLUMN_2, FEATURE_FLAG_KEYS.GRID_COLUMN_3],
        2: [FEATURE_FLAG_KEYS.GRID_COLUMN_3, FEATURE_FLAG_KEYS.GRID_COLUMN_4],
    },
};

export const targetToCellCursorIndexMap = {
    [GRID_LAYOUT_TYPE.SPLIT_H_2C]: {
        0: [0, 1],
    },
    [GRID_LAYOUT_TYPE.SPLIT_H_3C]: {
        0: [0, 1],
        1: [1, 2],
    },
    [GRID_LAYOUT_TYPE.SPLIT_H_4C]: {
        0: [0, 1],
        1: [1, 2],
        2: [2, 3],
    },
    [GRID_LAYOUT_TYPE.SPLIT_V_2C]: {
        0: [0, 1],
    },
    [GRID_LAYOUT_TYPE.SPLIT_V_3C]: {
        0: [0, 1],
        1: [1, 2],
    },
    [GRID_LAYOUT_TYPE.SPLIT_V_4C]: {
        0: [0, 1],
        1: [1, 2],
        2: [2, 3],
    },
    [GRID_LAYOUT_TYPE.SPLIT_V_1C_2C]: {
        0: [0, 1],
        1: [1, 2],
        2: [0, 2],
    },
    [GRID_LAYOUT_TYPE.SPLIT_V_1C_3C]: {
        0: [0, 1],
        1: [1, 2],
        2: [0, 2],
        3: [2, 3],
        4: [0, 3],
    },
    [GRID_LAYOUT_TYPE.SPLIT_V_2C_1C]: {
        0: [0, 1],
        1: [0, 2],
        2: [1, 2],
    },
    [GRID_LAYOUT_TYPE.SPLIT_V_3C_1C]: {
        0: [0, 1],
        1: [0, 3],
        2: [1, 2],
        3: [1, 3],
        4: [2, 3],
    },
    [GRID_LAYOUT_TYPE.SPLIT_H_1C_2C]: {
        0: [1, 2],
        1: [0, 1],
        2: [0, 2],
    },
    [GRID_LAYOUT_TYPE.SPLIT_H_1C_3C]: {
        0: [1, 2],
        1: [0, 1],
        2: [2, 3],
        3: [0, 2],
        4: [0, 3],
    },
    [GRID_LAYOUT_TYPE.SPLIT_H_2C_1C]: {
        0: [0, 2],
        1: [0, 1],
        2: [1, 2],
    },
    [GRID_LAYOUT_TYPE.SPLIT_H_3C_1C]: {
        0: [0, 3],
        1: [0, 1],
        2: [1, 3],
        3: [1, 2],
        4: [2, 3],
    },
    [GRID_LAYOUT_TYPE.SPLIT_2CX2]: {
        0: [0, 1],
        1: [0, 2],
        2: [1, 3],
        3: [2, 3],
    },
    [GRID_LAYOUT_TYPE.SPLIT_2CX3]: {
        0: [0, 1],
        1: [0, 2],
        2: [1, 3],
        3: [2, 3],
        4: [2, 4],
        5: [3, 5],
        6: [4, 5],
    },
    [GRID_LAYOUT_TYPE.SPLIT_3CX2]: {
        0: [0, 1],
        1: [0, 3],
        2: [1, 2],
        3: [1, 4],
        4: [2, 5],
        5: [3, 4],
        6: [4, 5],
    },
    [GRID_LAYOUT_TYPE.SPLIT_3CX3]: {
        0: [0, 1],
        1: [0, 3],
        2: [1, 2],
        3: [1, 4],
        4: [2, 5],
        5: [3, 4],
        6: [3, 6],
        7: [4, 5],
        8: [4, 7],
        9: [5, 8],
        10: [6, 7],
        11: [7, 8],
    },
};

export const relatedCursorIndexMap = {
    [GRID_LAYOUT_TYPE.SPLIT_V_1C_2C]: {
        0: [2],
        2: [0],
    },
    [GRID_LAYOUT_TYPE.SPLIT_V_1C_3C]: {
        0: [2, 4],
        2: [0, 4],
        4: [0, 2],
    },
    [GRID_LAYOUT_TYPE.SPLIT_V_2C_1C]: {
        1: [2],
        2: [1],
    },
    [GRID_LAYOUT_TYPE.SPLIT_V_3C_1C]: {
        1: [3, 4],
        3: [1, 4],
        4: [1, 3],
    },
    [GRID_LAYOUT_TYPE.SPLIT_H_1C_2C]: {
        1: [2],
        2: [1],
    },
    [GRID_LAYOUT_TYPE.SPLIT_H_1C_3C]: {
        1: [3, 4],
        3: [1, 4],
        4: [1, 3],
    },
    [GRID_LAYOUT_TYPE.SPLIT_H_2C_1C]: {
        0: [2],
        2: [0],
    },
    [GRID_LAYOUT_TYPE.SPLIT_H_3C_1C]: {
        0: [2, 4],
        2: [0, 4],
        4: [0, 2],
    },
    [GRID_LAYOUT_TYPE.SPLIT_2CX2]: {
        0: [3],
        1: [2],
        2: [1],
        3: [0],
    },
    [GRID_LAYOUT_TYPE.SPLIT_2CX3]: {
        0: [3, 6],
        1: [2],
        2: [1],
        3: [0, 6],
        4: [5],
        5: [4],
        6: [0, 3],
    },
    [GRID_LAYOUT_TYPE.SPLIT_3CX2]: {
        0: [5],
        1: [3, 4],
        2: [6],
        3: [1, 4],
        4: [1, 3],
        5: [0],
        6: [2],
    },
    [GRID_LAYOUT_TYPE.SPLIT_3CX3]: {
        0: [5, 10],
        1: [3, 4],
        2: [7, 11],
        3: [1, 4],
        4: [1, 3],
        5: [0, 10],
        6: [8, 9],
        7: [2, 11],
        8: [6, 9],
        9: [6, 8],
        10: [0, 5],
        11: [2, 7],
    },
} as const;
